import CrudCustom from '../../../libs/custom/CrudCustom';

let KoreksiFiskalService = new CrudCustom('/transaksi-koreksi-fiskals');
export default KoreksiFiskalService;
